import { connect } from 'react-redux';
import { loadSeasons, setActiveSeason } from '../../store/actions/seasons';
import { changePage, isLoading } from '../../store/actions/app';
import Seasons from '../../components/Pages/Seasons';

const mapStateToProps = state => {

    // console.log( 'containers.Pages.Seasons.mapStateToProps', state );

    return {
        context:    state.auth.context,
        lastUpdate: state.items.seasons.lastUpdate ? new Date( state.items.seasons.lastUpdate ) : null,
        loading:    state.app.loading,
        seasons:    state.items.seasons.items,
        token:      state.auth.token
    };

};

const mapDispatchToProps = dispatch => {

    return {
        onChangePage:   route => dispatch( changePage( route ) ),
        onLoadSeasons:  ( context, token ) => dispatch( isLoading( true ) ) && dispatch( loadSeasons( context, token ) ),
        onSelectSeason: season => dispatch( setActiveSeason( season ) )
    };

};

export default connect( mapStateToProps, mapDispatchToProps )( Seasons );